import { render, staticRenderFns } from "./ErrorAccount.vue?vue&type=template&id=25a68c0b"
import script from "./ErrorAccount.vue?vue&type=script&lang=ts"
export * from "./ErrorAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports